<template>
  <div class="pa-3">
    <v-row justify="right" align="center" v-show="!isView">
      <v-col class="d-flex flex-row" cols="12" md="12" lg="12" sm="12" align="center" justify="center">
        <v-autocomplete
          filled
          :items="campaignList"
          label="Campaign"
          item-value="id"
          hide-details
          item-text="name"
          v-model="campaignID"
        >
          <template v-slot:item="{ item }">
            <div>
              {{item.name}}&nbsp;&nbsp;
              <v-chip color="error" v-if="item.lockedCOGS" small>
                <span style="color:#fff"><v-icon v-on="on" small left>mdi-lock</v-icon> Locked COGS</span>
              </v-chip>
            </div>
          </template>
        </v-autocomplete>
        <v-btn
          class="ml-2 secondary"
          style="height:56px"
          :disabled="!campaignCOEB.campaignId"
          small
          @click="refreshPairingInfFromIMS(campaignCOEB)"
        >
          <v-icon small>mdi-cached</v-icon> Refresh
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="campaignCOEB">
        <v-card color="#CFD8DC">
          <!-- <v-card-subtitle class="subtitle-1 pb-0">{{ client ? client.name : '' }}</v-card-subtitle> -->
          <v-card-subtitle class="title pb-0">
            Campaign Name: {{ campaignCOEB.campaignName || 'N/A' }}
            <v-chip color="error" v-if="campaignCOEB.lockedCOGS" small>
              <span style="color:#fff"><v-icon v-on="on" small left>mdi-lock</v-icon>Locked COGS</span>
            </v-chip>            
            <v-btn
              small
              class="secondary"
              @click="openLockedCOGSDialog(campaignCOEB)"
              v-if="!isAdmin && disableLockedCOGS"
            >
              <v-icon small>mdi-lock-open</v-icon> Request Unlock
            </v-btn>
            <v-btn
              class="secondary"
              @click="changeLock(campaignCOEB, false)"
              v-if="isAdmin && disableLockedCOGS && !isView"
            >
              <v-icon small>mdi-lock-open</v-icon> Unlock
            </v-btn>
            <v-btn
              class="secondary"
              @click="changeLock(campaignCOEB, true)"
              v-if="showLockBtn"
            >
              <v-icon small>mdi-lock</v-icon> Lock
            </v-btn>
          </v-card-subtitle>
          <v-card-title class="subtitle-1">
            Client Name: {{ campaignCOEB.clientName || 'N/A' }}
          </v-card-title>
          <v-card-subtitle class="subtitle-1 pt-2">
            IO Number: {{ campaignCOEB.ioNumbers || 'N/A' }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Contents</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.min_content }} to {{ campaignCOEB.max_content }}</p>
              <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>                            
              <p class="pa-0 ma-0 custom-font" v-if="measurement.totalPercentage && measurement.totalPercentage !== 'NaN' && measurement.totalPercentage !== 'Infinity'">Percentage: {{measurement.totalPercentage}} %</p>
              <p class="pa-0 ma-0 custom-font" v-else>Percentage: {{measurement.totalPercentage}} %</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Outreach</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.outreach | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.outreach | thousandSeprator}}</p>
              <p class="pa-0 ma-0 custom-font" v-if="measurement.outreachPercentage && measurement.outreachPercentage !== 'NaN' && measurement.outreachPercentage !== 'Infinity'">Percentage: {{measurement.outreachPercentage}}%</p>
              <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Engagement</v-card-title>
            <v-card-subtitle>
              <p
                class="pa-0 ma-0 custom-font"
              >Target : {{ campaignCOEB.engagement | thousandSeprator}}</p>
              <p
                class="pa-0 ma-0 custom-font"
              >Current Total: {{measurement.engagement | thousandSeprator}}</p>         
              <p class="pa-0 ma-0 custom-font" v-if="measurement.engagementPercentage && measurement.engagementPercentage !== 'NaN' && measurement.engagementPercentage !== 'Infinity'">Percentage: {{measurement.engagementPercentage}}%</p>
              <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="12" lg="3" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            color="#363636"
            dark
            :elevation="hover ? 12 : 2"
            :class="{ 'on-hover': hover }"
          >
            <v-card-title class="headline">Budget</v-card-title>
            <v-card-subtitle>
              <p class="pa-0 ma-0 custom-font" v-if="budget">Target : {{ budget | currency }}</p>
              <p class="pa-0 ma-0 custom-font" v-else>Target : 0</p>
              <p class="pa-0 ma-0 custom-font">COGS: {{measurement.budget | currency}}</p> 
              <p
                class="pa-0 ma-0 custom-font"
                v-if="measurement.cogsPercentage && measurement.cogsPercentage !== 'NaN' && measurement.cogsPercentage !== 'Infinity'"
              >Percentage: {{measurement.cogsPercentage}}%</p>
              <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <!-- Pairing Data Table Section -->
    <v-layout class="mt-2 flex-row-reverse" wrap>
      <v-row style="width:100%">
        <v-col cols="12" sm="8" md="8" lg="8">
          <v-btn
            class="secondary"
            small
            v-if="selectedItems && selectedItems.length > 0"
            @click="openMultipleEstimatedLiveDateDialog()"
          >Update Estimated Live Month ({{selectedItems.length}})</v-btn>
          <v-btn
            class="ml-2 secondary"
            small
            v-if="selectedItems && selectedItems.length > 0"
            @click="openMultipleSubmissionDateDialog()"
          >Update Submission Date ({{selectedItems.length}})</v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4">
          <v-text-field
          v-model="briefConfirmationSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
          </v-text-field>
        </v-col>
      </v-row>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="computedPairedHeaders"
          :items="pairedInfluencers"
          :items-per-page="10"
          :search="briefConfirmationSearch"
          :no-data-text="'Empty list'"
          class="elevation-1 page__table"              
          :key="dataTableKey"
          show-select
          :single-select="false"
          v-model="selectedItems"
          @toggle-select-all="selectAllItems"
        >
          <template v-slot:body="props">
            <tbody>
              <tr v-if="props.items && props.items.length === 0">
                <td>No Data</td>
              </tr>
              <tr v-for="item in props.items" :key="item.id">
                <td style="min-width:100px;padding: 0 14px!important;">
                  <v-checkbox
                    style="padding-left:18px"
                    class="multi-select-checkbox"
                    v-model="item.isSelected"
                    label=""
                    color="grey darken-2"
                    @change="actionSelectChange"
                  ></v-checkbox>
                </td>
                <td class="invoice-handle-column">
                  <div class="d-flex align-center">
                    <social-handle divClassName="d-inline"
                    :isTikTok="item.influencer_details.platform === 'tiktok'"
                    :isInstagram="!item.influencer_details.platform || item.influencer_details.platform === 'instagram'"
                    :isFacebook="item.influencer_details.platform === 'facebook'"
                    :isLinkedIn="item.influencer_details.platform === 'linkedin'"
                    :isTwitter="item.influencer_details.platform === 'twitter'"
                    :isYoutube="item.influencer_details.platform === 'youtube'"
                    :isXiaohongshu="item.influencer_details.platform === 'xiaohongshu'"
                    :isOthers="item.influencer_details.platform === 'others'"
                    :tiktokHandle="item.influencer_details.instagramHandle"
                    :instagramHandle="item.influencer_details.instagramHandle"
                    :facebookHandle="getFacebookHandle(item.influencer_details)"
                    :linkedinHandle="item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle"
                    :twitterHandle="item.influencer_details.twitterHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle"
                    :youtubeHandle="item.influencer_details.instagramHandle"
                    :otherHandle="item.influencer_details.instagramHandle"
                    :xiaohongshuHandle="item.influencer_details.xhsID" :xiaohongshuFullName="item.influencer_details.fullName"
                    :youtubeURL="item.influencer_details.url" />
                    <v-menu bottom origin="center center"
                      transition="scale-transition"
                      v-if="item.multipleInfs && item.multipleInfs.length > 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn dark text v-bind="attrs" v-on="on" style="min-width:0;padding:0;margin-left:-9px;margin-top:-3px;">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon class="ml-2" color="secondary" v-on="on" small>mdi-chevron-down-circle</v-icon>
                              </template>
                              <span>Multiple Accounts detected</span>
                            </v-tooltip>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-for="(obj, i) in item.multipleInfs" :key="i" link><v-list-item-title><a v-if="obj.xhs"><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a><a v-else-if="obj.facebook"><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a><a v-else-if="obj.linkedin"><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{obj.handle}}</a><a v-else-if="obj.twitter"><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{obj.handle}}</a><a v-else-if="obj.tiktok"><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a><a v-else-if="obj.youtube"><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a><a v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-tooltip v-if="item.influencer_details.influencerID" bottom><template v-slot:activator="{ on }"><v-icon @click="true" color="green" v-on="on">done</v-icon></template><span>Registered on IMS</span></v-tooltip>
                    <v-tooltip v-if="!item.influencer_details.influencerID" bottom><template v-slot:activator="{ on }"><v-icon @click="true" color="red" v-on="on">cancel</v-icon></template><span>Not in IMS</span></v-tooltip>
                  </div>
                </td>
                <td class="invoice-platform-column">
                  <span>{{ item.platformName | platformDisplayName }}</span>
                </td>
                <td>
                  <span v-if="item.influencer_details.followers !== undefined && item.influencer_details.followers !== null">{{ item.influencer_details.followers }}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="item.influencer_details.platform !== 'facebook' && item.engagement_rate !== '0.00' && item.engagement_rate">{{ item.influencer_details.engagement_rate }}%</span>
                  <span class="caption" v-else-if="item.engagement_rate === '0.00'">
                    <v-icon small data-toggle="tooltip" data-placement="top" title="Hidden">mdi-eye-off</v-icon>
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <v-icon :color="item.influencer_details.audience_credibility_color">supervised_user_circle</v-icon>
                  {{ item.influencer_details.audience_credibility }}
                </td>
                <td>{{ formatDeliverableCounts(item.deliverablesDisplay) }}</td>
                <td class="text-right">
                  <span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{utilsFunc.currencySym(item.currency)}} {{item.payoutAmount | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{ item.payoutAmount }}</span>
                    </v-tooltip>
                  </span>
                </td>
                <td class="text-right">
                  <span v-if="item.GSTpercent">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                        {{utilsFunc.currencySym(item.currency)}} {{(item.payoutAmount - item.GSTpercent) | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{(item.payoutAmount - item.GSTpercent) | thousandSeprator}}</span>
                    </v-tooltip>
                  </span>
                  <span v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{utilsFunc.currencySym(item.currency)}} {{item.payoutAmount | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{item.payoutAmount | thousandSeprator}}</span><br>
                      <span v-if="item.sgdAmt">Estimated SGD: {{item.sgdAmt}}</span>
                    </v-tooltip>
                  </span>
                  <!-- <span v-if="!item.GSTIncluded">
                    {{utilsFunc.currencySym(item.currency)}} {{ item.payoutAmount }}
                  </span>
                  <span data-toggle="tooltip" data-placement="top" :title="displayGSTText(item)" v-if="item.GSTIncluded">
                    {{utilsFunc.currencySym(item.currency)}} {{(item.payoutAmount - item.GSTpercent) | thousandSeprator}}
                  </span> -->
                  <!-- <v-icon
                  small
                  color="warning"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="GST Included"
                  v-if="item.GSTIncluded">mdi-alert-circle-outline</v-icon> -->
                </td>
                <td class="text-right">
                  <span v-if="item.GSTIncluded">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{utilsFunc.currencySym(item.currency)}} {{ item.GSTpercent | thousandSeprator}}
                        </div>
                      </template>
                      <span>{{item.currency}} {{ item.GSTpercent | thousandSeprator}}</span>
                    </v-tooltip>
                  </span>
                </td>
                <td class="text-center">
                  {{ formatSubmissionDate(item.pairing_details.submission_date) }}
                  <v-btn
                    @click="openUpdateSubmissionDialog(item)"
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    v-show="!isView"
                  >
                    <v-icon small>edit</v-icon> <span>Update Date</span>
                  </v-btn>  
                </td>
                <td class="text-center">
                  {{ formatLiveMonth(item.pairing_details.estimatedLiveDate) }}
                  <v-btn
                    @click="openEstimatedLiveDateDialog(item)"
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    v-show="!isView"
                  >
                    <v-icon small>edit</v-icon> <span>Update Date</span>
                  </v-btn>  
                </td>
                <td v-show="!isView">
                  <v-btn color="primary" small @click="viewClick(item, 0)">
                    <v-icon color="secondary" small>edit</v-icon> Edit Invoice
                  </v-btn>
                  <v-btn class="mt-1" color="primary" small @click="viewClick(item, 1)">
                    <v-icon color="secondary" small>edit</v-icon> Edit Brief
                  </v-btn>
                </td>
                <!-- <td>
                  <v-btn color="warning" small @click="updateSend(item)">
                    <v-icon left>mdi-upload</v-icon> Update Send
                  </v-btn>
                </td> -->
                <td v-show="!isView">
                  <div>
                    <!-- <v-btn
                      v-if="item.signinForm"
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      @click="downloadSigningPDF(item.signinForm)"
                    >
                      <v-icon>download</v-icon>
                      <span>Download PDF</span>
                    </v-btn> -->
                    <div>
                      <v-btn
                        v-if="item.contact_details && item.contact_details.email && isCampaignAM && isCampaignCC && !item.signinForm && item.pairing_details.estimatedLiveDate"
                        @click="copySignInFormLink(item)"
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                        <span>Copy link</span>
                      </v-btn>
                      <v-btn
                        v-if="item.contact_details && !item.contact_details.email"
                        @click="openUpdateEmailDialog(item)"
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                      >
                        <v-icon color="secondary" small>edit</v-icon> <span>Update Email</span>
                      </v-btn>
                      <div>
                        <v-btn
                          v-if="!isCampaignAM || !isCampaignCC"
                          class="assign-am-cc-btn mt-2 mb-2 black--text"
                          small
                          depressed
                          color="yellow"
                        >
                          <v-icon small>mdi-alert-circle</v-icon>
                          Assign&nbsp;<span v-if="!isCampaignAM">AM</span><span v-if="!isCampaignCC && !isCampaignCC">,</span><span v-if="!isCampaignCC">CC</span>
                        </v-btn>
                      </div>
                      <div v-if="signingFormsForDownload(item).length" class="pt-1">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mb-1"
                              color="success"
                              v-bind="attrs"
                              v-on="on"
                              small
                              text>
                              <v-icon small>mdi-download</v-icon>&nbsp;Download
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(invoice, i) in signingFormsForDownload(item)"
                              :key="invoice.contractFile.url || i"
                              :href="invoice.contractFile.url"
                              target="_blank"
                            >
                              <v-list-item-content>{{utilsFunc.formatCustomDate(invoice.contractFile.timestamp || invoice.createdAt, 'DD/MM/YYYY hh:mm:ss A')}}</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <span v-if="!item.signinForm && !item.pairing_details.estimatedLiveDate">(Please update estimate live month)</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <v-btn
                      @click="copyContentScriptFormLink(item)"
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                    >
                      <v-icon small>mdi-content-copy</v-icon>
                      <span>Copy link</span>
                    </v-btn>
                  </div>
                  <!-- <div>
                    <v-btn
                      v-if="item.contentScriptForm"
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      @click="viewContentScriptDialog(item.id)"
                    >
                      <v-icon color="warning" small>edit</v-icon> <span>Edit</span>
                    </v-btn>
                  </div> -->
                </td>
                <td v-show="!isView">
                  <v-btn class="mb-1" color="success" small @click="viewClick(item, 2)">
                    <v-icon left>mdi-send</v-icon> Preview and Send
                  </v-btn>
                  <v-btn class="mb-1" color="success" small @click="confirmPayout(item)" v-if="item.payout_details && item.payout_details.status !== payoutStatus.CONFIRMED">
                    <v-icon left>mdi-check</v-icon> Confirm Payout
                  </v-btn>
                  <v-btn class="mb-1" color="error" small @click="cancelPayout(item)" :disabled="disableLockedCOGS" v-if="item.payout_details && item.payout_details.status === payoutStatus.CONFIRMED">
                    <v-icon left>mdi-cancel</v-icon> Cancel Payout
                  </v-btn>
                  <!-- <v-btn
                    small
                    color="warning"
                    @click="openLockedCOGSDialog(campaignCOEB)"
                    v-if="!isAdmin && disableLockedCOGS"
                  >
                    <v-icon color="white" small>mdi-lock-open</v-icon> Request Unlock
                  </v-btn>
                  <v-btn
                    small
                    color="warning"
                    @click="changeLock(campaignCOEB, false)"
                    v-if="isAdmin && disableLockedCOGS"
                  >
                    <v-icon color="white" small>mdi-lock-open</v-icon> Unlock
                  </v-btn> -->
                </td>
                <td>
                  <v-chip color="info" v-if="item.sentStatus === pairingSendStatus.DRAFT" outlined small>
                    <v-icon v-on="on" small>new_releases</v-icon>  {{pairingSendStatusDisplay[item.sentStatus]}}
                  </v-chip>
                  <v-chip color="green" v-if="item.sentStatus === pairingSendStatus.SENT" outlined small>
                    <v-icon v-on="on" small>done</v-icon>  {{pairingSendStatusDisplay[item.sentStatus]}}
                  </v-chip>
                  <v-chip color="green" v-if="item.sentStatus === pairingSendStatus.SIGNED" outlined small>
                    <v-icon v-on="on" small>done</v-icon>  {{pairingSendStatusDisplay[item.sentStatus]}}
                  </v-chip>
                  <div class="mt-1 mb-1">
                    <v-btn class="mb-1"
                      color="error"
                      small
                      @click="cancelAccept(item)"
                      v-if="(item.payout_details && item.payout_details.status !== payoutStatus.CONFIRMED) && (item.pairingStatus && item.pairingStatus === pairingStatus.ACCEPTED.value) && !isView">
                      <v-icon left>mdi-close</v-icon> Remove
                    </v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- End of Pairing Data Table -->

    <!-- Influencer Detail Modal -->
    <influencer-detail-modal
      :dialog="dialog" 
      :influencer="influencer" 
      :influencerProfile="influencerProfile" 
      :selectedTab="selectedTab"
      :briefDetailContent="briefDetailsHTML"
      :close="closeModal"      
      @loadInfluencer="loadInfluencerData"
      @reRenderDatTable="loadInfluencerData"
      @loadingDialogOpen="loadingDialogOpen" 
      @loadingDialogClose="loadingDialogClose"
      :newPairingFlow="true"
      :isDownload="invoiceDownload" 
      :isFinalPayout="isFinalPayout" />
    <!-- End of Influencer Detail Modal -->

    <v-dialog
      v-model="loadingDialog"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <input type="hidden" id="copy-link" :value="signinFormLink">
    <input type="hidden" id="copy-concept-link" :value="conceptFormLink">
    <!-- ViewFeedback modal -->
    <view-signin-form-modal v-model="viewSigninFormModalDialog" :value="viewSigninFormModalDialog" :signinFormData="viewSigninFormData" />
    <!-- Update Creator Email Modal -->
    <update-creator-email-modal
    v-model="updateCreatorEmailDialog"
    :value="updateCreatorEmailDialog"
    :pairing="viewPairingData"
    @updated="loadInfluencerData" />
    <!-- Update Creator Email Modal -->
    <update-submission-date-modal
    v-model="updateSubmissionDateDialog"
    :value="updateSubmissionDateDialog"
    :pairing="viewPairingData"
    @updated="loadInfluencerData" />
    <!-- Update estimated live date Modal -->
    <estimated-live-date-modal
    v-model="updateEstimatedLiveDateDialog"
    :value="updateEstimatedLiveDateDialog"
    :pairing="viewPairingData"
    :multiplePairings="multiplePairings"
    @updated="loadInfluencerData" />
    <!-- Update estimated live date Modal -->
    <submission-date-modal
    v-model="updateMultipleSubmissionDateDialog"
    :value="updateMultipleSubmissionDateDialog"
    :pairing="viewPairingData"
    :multiplePairings="multiplePairings"
    @updated="loadInfluencerData" />
    <!-- View content scripts modal -->
    <view-creator-concept-modal-dialog
    v-model="viewcontentScriptModalDialog"
    :value="viewcontentScriptModalDialog"
    :data="viewContentScriptsData"
    v-if="viewContentScriptsData"/>
    <v-snackbar
      v-model="copySucceeded"
    >
      Copied to Clipboard!
      <v-btn
        color="blue"
        text
        @click="copySucceeded = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    />
  </div>
</template>
<script>
import campaignConfig from '../config';
import campaignHelper from '../campaignHelper';
import campaignAPIs from '../campaignAPIs';
import clientAPIs from '../../Client/clientAPIs';
import UserAPIs from '../../User/userAPIs'
import pairingAPIs from '../../Pairing/pairingAPIs';
import config from '@/config';
import utils from '../../../../utils'
import influencerDetailModal from './InfluencerDetailViewModal'
import BlocksToHtml from '../../../editor/generator/blocksToHtml'
import SocialHandle from '../../../scoped/custom/SocialHandle'
import reverse from 'lodash/reverse'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import ViewSigninFormModal from '../../Influencer/SigningForm/ViewModalDialog'
import ViewCreatorConceptModalDialog from '../../Pairing/CreatorConcept/ViewModalDialog'
import UpdateCreatorEmailModal from './UpdateCreatorEmailModal'
import UpdateSubmissionDateModal from './UpdateSubmissionDateModal'
import EstimatedLiveDateModal from './EstimatedLiveDateModal'
import SubmissionDateModal from './SubmissionDateModal' // <-- ADDED IMPORT
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// import $ from 'jquery'

export default {
  name: 'invoices-brief-confirmation',
  props: {
    viewCampaignID: String,
    isView: Boolean
  },
  components: {
    influencerDetailModal,
    SocialHandle,
    ViewSigninFormModal,
    ViewCreatorConceptModalDialog,
    UpdateCreatorEmailModal,
    UpdateSubmissionDateModal,
    EstimatedLiveDateModal,
    SubmissionDateModal,
    Loading
  },
  data() {
    return {
      loading: false,
      utilsFunc: utils.func,
      viewSigninFormData: {},
      viewContentScriptsData: {},
      viewSigninFormModalDialog: false,
      viewcontentScriptModalDialog: false,
      updateMultipleSubmissionDateDialog: false, // <-- ADDED VARIABLE
      influencerList: [],
      totalInfluencer: 0,
      search: '',
      briefConfirmationSearch: '',
      filter: '',
      options: {},
      snack: false,
      snackColor: '',
      snackText: '',
      amount: 0,
      dialog: false, // for Influencer Detail Modal
      influencer: '', // for Influencer Detail Modal
      influencerProfile: '', // for Influencer Detail Modal
      loadAllQuestoins: [],
      selectedTab: '',
      loadingDialog: false,
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      briefDetailsHTML: '',
      campaignList: [],
      // Current selected campaign
      campaignID: '',
      pairedID: '',
      pairedInfluencers: [],
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      payoutStatusDisplay: campaignConfig.payoutStatusDisplay,
      payoutStatus: campaignConfig.payoutStatus,
      pairingSendStatusDisplay: campaignConfig.pairingSendStatusDisplay,
      pairingSendStatus: campaignConfig.pairingSendStatus,
      invoiceDownload: false,
      isFinalPayout: false,
      copySucceeded: false,
      pairedHeaders: [
        {
          text: 'Handle',
          value: 'influencer_details.userHandle',
          width: '210px',
          class: 'invoice-handle-column',
          cellClass: 'invoice-handle-column'
        },
        {
          text: 'Platform',
          value: 'platformName',
          width: '170px',
          class: 'invoice-platform-column',
          cellClass: 'invoice-platform-column'
        },
        {
          text: 'Followers',
          value: 'followers'
        },
        {
          text: 'Eng. Rate',
          value: 'engagement_rate'
        },
        {
          text: 'Aud. Cred',
          value: 'audience_credibility'
        },
        {
          text: 'Deliverable Details',
          value: 'deliverablesDisplay'
        },
        {
          text: 'Payout Amount (Inclusive GST)',
          value: 'payoutAmount'
        },
        {
          text: 'Payout Amount (Exclusive GST)',
          value: 'payoutAmountExclusive'
        },
        {
          text: 'GST Amount',
          value: 'gstAmount'
        },
        {
          text: 'Submission Date',
          value: 'submission_date'
        },
        {
          text: 'Estimated Live Month',
          value: 'estimatedLiveMonth'
        },
        {
          text: 'Creators Invoice, Contract & Brief',
          value: 'creatorInvoice'
        },
        // {
        //   text: 'Creators Brief',
        //   value: ''
        // },
        {
          text: 'Signing Form',
          value: 'signinForm'
        },
        {
          text: 'Content Scripts Form',
          value: 'contentScriptForm'
        },
        {
          text: 'Confirmation',
          value: 'confirmation'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ],
      signinFormLink: '',
      conceptFormLink: '',
      viewPairingData: null,
      multiplePairings: null,
      updateCreatorEmailDialog: false,
      updateSubmissionDateDialog: false,
      updateEstimatedLiveDateDialog: false,
      allClients: [],
      selectedItems: []
    };
  },
  mounted() {
    this.fetchCampaignList()
    this.getAllUsers()
    this.getAllClients()
    this.$store.dispatch('payment/getCurrencyRates')
  },
  watch: {
    campaignID(value) {
      this.$router.push({
        path: '/influencers/invoices-brief-confirmation',
        query: {
          id: value
        }
      })
      this.getPairedInfluencers(value, false);
    },
    viewCampaignID (value) {
      this.pairedInfluencers = []
      this.getPairedInfluencers(value, false);
    }
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    ...mapState({
      requestedPayoutEdit: state => state.pairing.requestedPayoutEdit,
      saved: state => state.pairing.saved,
      campaignUpdated: state => state.campaign.campaignUpdated,
      infDetail: state => state.influencer.infDetail,
      currencyRates: state => state.payment.currencyRates
    }),
    computedPairedHeaders() {
      if (this.isView) {
        return this.pairedHeaders.filter(p => p.value !== 'creatorInvoice' && p.value !== 'confirmation' && p.value !== 'signinForm')
      } else {
        return this.pairedHeaders
      }
    },
    params(nv) {
      return {
        ...this.options
      };
    },
    currentUser() {
      return this.$store.state.user;
    },
    isAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW
    },
    isCampaignAM: function() {
      if (this.campaignCOEB.campaignId) {
        let matchUser = this.campaignCOEB.Users.find(u => u.role === config.userRoles.ACCOUNT_MANAGER)
        if (matchUser) {
          return true
        }
        return false
      }
      return true
    },
    isCampaignCC: function() {
      if (this.campaignCOEB.campaignId) {
        let matchUser = this.campaignCOEB.Users.find(u => u.role === config.userRoles.AD_STRATEGIST)
        if (matchUser) {
          return true
        }
        return false
      }
      return true
    },
    budget: function() {
      let campaignClient = this.allClients.find(client => client.id === this.campaignCOEB.clientID)
      let markupCOGSAmount = campaignHelper.getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient)
      return markupCOGSAmount || Math.floor(this.campaignCOEB.budget * 0.26)
    },
    disableLockedCOGS() {
      return this.campaignCOEB.lockedCOGS || false
    },
    showLockBtn() {
      if (this.campaignCOEB.campaignId && !this.campaignCOEB.lockedCOGS &&
      (Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === config.userRoles.AD_STRATEGIST)) {
        return true
      }
      return false
    }
  },
  methods: {
    formatDeliverableCounts(value) {
      return String(value || '')
        .replace(/X \(Twitter\) Post/g, 'XTP')
        .replace(/(\d+(?:hrs)?) X /g, '$1 x ')
    },
    getFacebookHandle(influencerDetails = {}) {
      const facebook = influencerDetails.facebook && typeof influencerDetails.facebook === 'object'
        ? influencerDetails.facebook
        : {}
      return influencerDetails.facebookHandle || influencerDetails.fbHandle || facebook.handle || facebook.facebookHandle || influencerDetails.facebookId || facebook.facebookId || influencerDetails.userHandle || influencerDetails.instagramHandle || ''
    },
    async getPairedInfluencers(campaignID) {
      this.isLoading = true
      const campaignResp = await campaignAPIs.getCampaign(campaignID)
      if (campaignResp) {
        if (campaignResp.campaignType === undefined) {
          this.$swal({
            title: 'Error',
            text: 'Invalid Campaign Type!',
            type: 'error'
          }).then(() => {
          });
          this.$emit('confirmBrief')
          this.isLoading = false
          this.$emit('closeBriefModal')
          return false
        }
        let client = null
        try {
          client = await clientAPIs.getClient(campaignResp.clientID)
        } catch (error) {
          // Get all elements with the specified class name
          const elements = document.getElementsByClassName('vld-overlay');
          // Convert the HTMLCollection to an array and loop through it
          Array.from(elements).forEach(element => {
            element.remove(); // Remove each element from the DOM
          });
          // vue2 got issue and not sure why loading can't set false, so used document element above
          this.$swal({
            title: 'Error',
            text: 'Invalid Client!',
            type: 'error'
          }).then(() => {
            this.isLoading = false
            this.$emit('closeBriefModal')
          });
          return false
        }
        const Users = this.Users.filter(c => (campaignResp.assignedTo && campaignResp.assignedTo.includes(c.id)))
        this.campaignCOEB = Object.assign(
          {},
          {
            campaignId: campaignResp.id,
            campaignName: campaignResp.name,
            companyID: campaignResp.companyID,
            clientID: campaignResp.clientID,
            ioNumbers: campaignResp.ioNumbers,
            clientName: client.name,
            Users,
            campaignOutreach: campaignResp.outreach,
            campaignEngagement: campaignResp.engagement,
            campaignBudget: campaignResp.budget,
            max_content: campaignResp.max_content,
            min_content: campaignResp.min_content,
            outreach: campaignResp.outreach,
            engagement: campaignResp.engagement,
            budget: campaignResp.budget,
            campaign_brief_details: campaignResp,
            lockedCOGS: campaignResp.lockedCOGS
          }
        )
      }
      const pairingResp = await pairingAPIs.getPairedInfluencersByCampaign(campaignID)
      if (pairingResp) {
        let items = [];
        for (let data of pairingResp) {
          let inf = this.beautifyData(data);
          // if (inf.eliminationStatus === campaignConfig.eliminationStatus.SELECTED) {
          //   items.push(inf);
          // }
          if (inf.pairingStatus === campaignConfig.pairingStatus.ACCEPTED) {
            items.push(inf);
          }
        }
        this.pairedInfluencers = Object.assign([], items);
        this.setMultipleInfs()
        this.campaignMeasurement(items)
        /**
         * #NOTE
         * filter invited influencer list
         */
        const invitedItems = items
        .filter(e => e.pairingStatus !== campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementInvited(invitedItems)

        /**
         * #NOTE
         * filter not invited influencer list
         */
        const notInvitedItems = items
        .filter(e => e.pairingStatus === campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementNotInvited(notInvitedItems)
      }
      this.isLoading = false
    },
    campaignMeasurement(items) {
      // console.log('Campaign Outreach', this.campaignCOEB.outreach)
      this.measurement.total = 0
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(item => {
        this.measurement.total += Number(this.calculateContents(item))
        this.measurement.outreach += Number(this.calculateOutreach(item));
        this.measurement.engagement += Number(this.calculateEngagement(item));
        let amt = Number((item.payout - (item.GSTpercent || 0)) || 0);
        if (item.currency !== 'SGD') {
          // convert rate if not sgd
          let rate = this.currencyRates[item.currency]
          amt = Number(amt / rate).toFixed(2)
        }
        this.measurement.budget += Number(amt || 0);
      })
      let content = (this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaignCOEB.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaignCOEB.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.campaignCOEB.budget) * 100).toFixed(2);
    },
    campaignMeasurementInvited(items) {
      this.measurement.invitedTotal = 0
      items.map(item => {
        this.measurement.invitedTotal += Number(this.calculateContents(item))
        this.measurement.invitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.invitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.invitedBudget += Number(item.payout || 0);
      })
    },
    campaignMeasurementNotInvited(items) {
      this.measurement.notInvitedTotal = 0
      items.map(item => {
        this.measurement.notInvitedTotal += Number(this.calculateContents(item))
        this.measurement.notInvitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.notInvitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.notInvitedBudget += Number(item.payout || 0);
      })
    },
    async getInfluencer() {
      this.pairedID = this.$route.params.pairedID;
      if (this.pairedID) {
        const response = await pairingAPIs.getPairedInfluencer(this.pairedID)
        this.viewClick(response.items)
      }
    },
    async loadQuestions(campaignID, userID) {
      let allQuestions = await pairingAPIs.getQuestions(campaignID, userID)
      let questionArray = [];
      // console.log('all question', allQuestions)
      for (let questionObj of allQuestions) {
        // console.log('Question', questionObj.question)
        questionArray.push(questionObj)
      }
      this.loadAllQuestoins = questionArray;
    },
    formatPayout(n) {
      if (n.toString().indexOf('-') !== -1) {
        let str = n.toString().split('-')
        return utils.func.formatCurrency(parseFloat(str[0])) + ' - ' + str[1]
      } else {
        return utils.func.formatCurrency(parseFloat(n))
      }
    },
    UpdatePayout (id, payout) {
      let params = {
        'pairedID': id,
        'amount': payout
      }
      pairingAPIs.updatePayoutById(params).then(res => {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = `Updated Payout to: ${payout}`
      })
    },
    onKeyPressHandle(event) {
      if (event.key === 'Enter') {
        if (this.search) this.searchClick();
        else this.loadInfluencerData();
      }
    },
    onChangeHandle(event) {
      if (event.target.value === '') {
        this.loadInfluencerData();
      }
    },
    async fetchPairedInfluencerFromAPI(page, limit) {
      let userID;
      if (this.currentUser.role === config.userRoles.AD_STRATEGIST || this.currentUser.role === config.userRoles.ACCOUNT_MANAGER) {
        userID = this.currentUser.id;
      }
      const influencer = await pairingAPIs.getAllPairedInfluencer(userID, page, limit);
      // this.influencerList = influencer;
      return influencer;
    },
    searchClick() {
      if (this.search) {
        this.loading = true;
        let userID;
        let search = this.search.trim().toLowerCase();
        if (this.currentUser.role === config.userRoles.AD_STRATEGIST || this.currentUser.role === config.userRoles.ACCOUNT_MANAGER) {
          userID = this.currentUser.id;
        }
        pairingAPIs.getAllPairedInfluencer(userID).then(data => {
          // console.log('Search items', items)
          if (search) {
            data.items = data.items.filter(item => {
              return Object.values(item).join(',').toLowerCase().includes(search);
            });
            // console.log('Search items', items)
          }
          this.influencerList = data.items;
          this.totalInfluencer = data.items.length
          this.loading = false;
        });
      } else this.loadInfluencerData(); // default data
    },
    loadInfluencerData() {
      this.getPairedInfluencers(this.campaignID)
      this.loadingDialog = false;
      this.multiplePairings = []
      this.selectedItems = []
      // this.loading = true;
      // this.prepareDataTable().then(data => {
      //   this.influencerList = data.items;
      //   this.totalInfluencer = data.total;
      //   this.loading = false;
      //   // this.dialog = false;
      //   this.loadingDialog = false;
      // });
    },
    prepareDataTable() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        this.fetchPairedInfluencerFromAPI(page, itemsPerPage).then(data => {
          // console.log('Fetch items', data.items);
          // if (filter) {
          //   data.items = data.items.filter(item => {
          //     return Object.values(data.items).join(',').toLowerCase().includes(filter);
          //   });
          // }
          if (this.options.sortBy) {
            data.items = data.items.sort((a, b) => {
              const sortA = a[sortBy[0]];
              const sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }

          // if (itemsPerPage > 0) {
          //   data.items = data.items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
          // }
          const total = data.totalRows;
          setTimeout(() => {
            resolve({ items: data.items, total });
          }, 300);
        });
      });
    },
    getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return ''
      } else if (status === this.payoutStatus.INCOMPLETE) {
        return 'warning'
      } else {
        return 'green'
      }
    },
    getUserByInfluencer(id) {
      // console.log('influencerID', id)
      let param = {
        'influencerID': id
      }
      UserAPIs.getUserByInfluencer(param)
      .then(res => {
        // console.log('Response user by influencerID', res)
        this.influencerProfile = res
      })
    },
    preSelectTabs (status) {
      if (status === this.pairingStatus.INQUIRY.value) {
        this.selectedTab = 1
      } else {
        this.selectedTab = 0
      }
    },
    async preparedViewItem(item, type) {
      // Get Influencer user profile only if have InfluencerID
      if (item.influencerID) {
        this.getUserByInfluencer(item.influencerID)
      }
      this.influencer = Object.assign({}, item)
      // ---------- if HTML data, get content HTML ----------
      if (item.brief_details && item.brief_details.contentHTML !== undefined && item.brief_details.contentHTML !== null) {
        this.briefDetailsHTML = item.brief_details.contentHTML
        this.selectedTab = type
        return;
      }
      // ---------- if not HTML Content, convert to HTML Content ---------- //
      let oldData = false
      if (item.brief_details && item.brief_details.content !== undefined && item.brief_details.content !== '' && item.brief_details.content.length > 0) {
        this.briefDetailContent.blocks = item.brief_details.content
        oldData = true
      } else {
        // this.briefDetailContent = ''
        this.briefDetailContent.blocks = await campaignHelper.generateBlocks(item)
      }
      let blocksTohtml = new BlocksToHtml(this.briefDetailContent.blocks)
      this.briefDetailsHTML = blocksTohtml.generate(oldData)
      this.selectedTab = type
    },
    async viewClick(item, type) {
      if (type === 2 && item.brief_details === undefined) {
        this.briefDetailContent.blocks = await campaignHelper.generateBlocks(item)
        let blocksTohtml = new BlocksToHtml(this.briefDetailContent.blocks)
        this.briefDetailsHTML = blocksTohtml.generate(false)
        let data = {
          pairingID: item.id,
          userID: this.currentUser.id,
          contentHTML: this.briefDetailsHTML
        }
        await pairingAPIs.updatePairingBriefDetails(data)
        item.brief_details = {
          userID: this.currentUser.id,
          contentHTML: this.briefDetailsHTML
        }
      }
      this.invoiceDownload = false
      await this.preparedViewItem(item, type)
      this.selectedTab = type
      this.dialog = true
    },
    async confirmPayout(item) {
      this.isLoading = true
      const pairedResp = await pairingAPIs.getPairedInfluencer(item.id)
      if (pairedResp.items) {
        if (pairedResp.items.id) {
          if (pairedResp.items.status !== config.pairingStatus.ACCEPTED) {
            this.$swal({
              type: 'warning',
              text: 'Please accept influencer for pairing.'
            })
            return
          }
        }
      }
      const payload = this.getRptOwnerCheckPayload(item)
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      let confirmPayoutBlock = campaignConfig.campaignConfirmation.confirmPayout
      let message = confirmPayoutBlock.html
      this.isFinalPayout = false
      // let vm = this
      this.isLoading = false
      if (this.checkFinalPayoutConfirm(item)) {
        // for final payout, lock confirm payout
        this.$swal({
          title: confirmPayoutBlock.title,
          html: message,
          confirmButtonText: confirmPayoutBlock.confirmButtonText,
          type: 'info',
          showCancelButton: true,
          showCloseButton: true
        }).then(async (result) => {
          if (result.value) {
            this.invoiceDownload = true
            this.isFinalPayout = true
            await this.preparedViewItem(item, -1)
            this.selectedTab = -1
            this.dialog = true
          }
        });
        // this.$swal({
        //   title: 'Confirm Final Payout!',
        //   html: 'We have detected that this is the last payout confirmation. Please confirm that all lineup and payouts are final.',
        //   confirmButtonText: `Yes, It's Final`,
        //   closeButtonText: 'No',
        //   type: 'info',
        //   confirmButtonColor: '#4caf50',
        //   showCloseButton: true,
        //   showConfirmButton: true
        // }).then(async (result) => {
        //   if (result.value) {
        //     this.invoiceDownload = true
        //     this.isFinalPayout = true
        //     await this.preparedViewItem(item, -1)
        //     this.selectedTab = -1
        //     this.dialog = true
        //   }
        // });
        // add custom buttons to swal alert by using jquery since swal alert2 does not support three buttons
        // $('.swal2-actions').append(`<button type="button" class="swal2-cancel custom-not-final-btn swal2-styled" aria-label="" style="display: inline-block; background-color: #3085d6;">Not Final</button>`)
        // $('.swal2-actions').append(`<button type="button" class="swal2-cancel custom-cancel-btn swal2-styled" aria-label="" style="display: inline-block;">Cancel</button>`)
        // $('.custom-not-final-btn').click(async function() {
        //   $('.swal2-close').click()
        //   vm.invoiceDownload = true
        //   await vm.preparedViewItem(item, -1)
        //   vm.selectedTab = -1
        //   vm.dialog = true
        // })
        // $('.custom-cancel-btn').click(function() {
        //   $('.swal2-close').click()
        // })
      } else {
        // if not final payout, continue confirm payout
        this.$swal({
          title: confirmPayoutBlock.title,
          html: message,
          confirmButtonText: confirmPayoutBlock.confirmButtonText,
          type: 'info',
          showCancelButton: true,
          showCloseButton: true
        }).then(async (result) => {
          if (result.value) {
            this.invoiceDownload = true
            await this.preparedViewItem(item, -1)
            this.selectedTab = -1
            this.dialog = true
          }
        });
      }
    },
    async cancelPayout(item) {
      // const payload = this.getRptOwnerCheckPayload(item)
      // await campaignHelper.invokeReportOwnerCheck(this, payload)
      let cancelPayoutBlock = campaignConfig.campaignConfirmation.cancelPayout
      let message = cancelPayoutBlock.html
      this.$swal({
        title: cancelPayoutBlock.title,
        html: message,
        confirmButtonText: cancelPayoutBlock.confirmButtonText,
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.loadingDialog = true
          let reasonText = document.getElementById('cancel-payout-reason').value
          if (!reasonText) {
            this.loadingDialog = false
            this.cancelPayout(item)
            return false
          }
          await pairingAPIs.cancelAdminPayout(item.id, reasonText)
          this.loadingDialog = false
          this.loadInfluencerData();
        }
      });
    },
    // async generateBlocks(item) {
    //   this.briefDetailContent.blocks = []
    //   /**
    //    * Create Objectives Array
    //    */
    //   let ObjectiveArray = []
    //   if (item.campaign_brief_details.goal) {
    //     for (let goal of item.campaign_brief_details.goal) {
    //       ObjectiveArray.push(goal)
    //     }
    //   }
    //   /**
    //    * Generate Blocks for EditorJs with campaign brief data
    //    */
    //   this.briefDetailContent.blocks.push(
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `<b>Client:</b> ${item.CampaignName}`
    //       }
    //     },
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `<b>Objectives</b>`
    //       }
    //     },
    //     {
    //       'type': 'list',
    //       'data': {
    //         'style': 'unordered',
    //         'items': ObjectiveArray
    //       }
    //     },
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `<b>Unique Advantage</b>`
    //       }
    //     },
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `${item.campaign_brief_details.uniqueAdvantage}`
    //       }
    //     },
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `<b>Common Objections</b>`
    //       }
    //     },
    //     {
    //       'type': 'paragraph',
    //       'data': {
    //         'text': `${item.campaign_brief_details.commonObjective}`
    //       }
    //     }
    //   )
    //   /**
    //    * Adding Deliverables if there any
    //    */
    //   if (item.deliverables) {
    //     let deliverableArray = []
    //     if (item.deliverables.no_of_tiktok_posts > 0) {
    //       deliverableArray.push(`${item.deliverables.no_of_tiktok_posts} x TikTok Post`)
    //     } else if (item.deliverables.no_of_posts > 0) {
    //       deliverableArray.push(`${item.deliverables.no_of_posts} x IG Carousel Post`)
    //     } else if (item.deliverables.no_of_stories > 0) {
    //       deliverableArray.push(`${item.deliverables.no_of_stories} x IG Story with swipe up link`)
    //     } else {
    //       deliverableArray.push(`${item.deliverables.no_of_video} x IG Video`)
    //     }

    //     this.briefDetailContent.blocks.push(
    //       {
    //         'type': 'paragraph',
    //         'data': {
    //           'text': `<b>Deliverables</b>`
    //         }
    //       },
    //       {
    //         'type': 'list',
    //         'data': {
    //           'style': 'unordered',
    //           'items': deliverableArray
    //         }
    //       }
    //     )
    //   }
    //   /**
    //    * Adding Content angles after looking for deliverables
    //    */
    //   let contentAngles = campaignHelper.fixAnglesData(item.campaign_brief_details.angles)
    //   for (let i = 0; i < contentAngles.length; i++) {
    //     this.briefDetailContent.blocks.push(
    //       {
    //         'type': 'paragraph',
    //         'data': {
    //           'text': `<b>Concept ${i + 1}: ${contentAngles[i].option_name}</b>`
    //         }
    //       },
    //       {
    //         'type': 'paragraph',
    //         'data': {
    //           'text': '<u>Campaign Context:</u>'
    //         }
    //       },
    //       {
    //         'type': 'paragraph',
    //         'data': {
    //           'text': `${contentAngles[i].context}`
    //         }
    //       },
    //     )
    //     for (let j = 0; j < contentAngles[i].formats.length; j++) {
    //       let format = contentAngles[i].formats[j]
    //       this.briefDetailContent.blocks.push(
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': '<u>Required action:</u>'
    //           }
    //         },
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': `${format.required_action}`
    //           }
    //         },
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': '<u>Image/Video Pointers:</u>'
    //           }
    //         },
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': `${format.image_angle}`
    //           }
    //         },
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': `<u>Content Pointers:</u>`
    //           }
    //         },
    //         {
    //           'type': 'paragraph',
    //           'data': {
    //             'text': `${format.content_angle}`
    //           }
    //         }
    //       )
    //       if (format.sample_images.length > 0) {
    //         this.briefDetailContent.blocks.push({
    //           'type': 'paragraph',
    //           'data': {
    //             'text': `<b>Image/Video Inspiration</b>`
    //           }
    //         })

    //         for (let s = 0; s < format.sample_images.length; s++) {
    //           let sampleImage = format.sample_images[s]
    //           if (sampleImage.type === 'image') {
    //             this.briefDetailContent.blocks.push({
    //               'type': 'image',
    //               'data': {
    //                 'url': `https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/${sampleImage.url}`,
    //                 'triggerRemoved': true
    //               }
    //             })
    //           } else {
    //             this.briefDetailContent.blocks.push({
    //               'type': 'paragraph',
    //               'data': {
    //                 'text': sampleImage.url
    //               }
    //             })
    //           }
    //         }
    //       }
    //     }
    //   }
    // },
    closeModal() {
      this.selectedTab = '';
      this.dialog = false;
    },
    loadInfluencerDataForBriefDetails() {
      this.prepareDataTable().then(data => {
        this.influencerList = data.items;
        this.totalInfluencer = data.total;
      });
    },
    loadingDialogOpen() {
      this.loadingDialog = true
    },
    loadingDialogClose() {
      this.loadingDialog = false
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts);
    },
    calculateEngagement(item) {
      const engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts);
    },
    beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      // inf = data.influencer_details;
      inf.influencer_details = influencerDetails;
      inf.contact_details = influencerDetails.contact_details;
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.influencerID = influencerDetails.influencerID || null
      inf.pairingStatus = data.pairing_details.status;
      inf.status = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.Users = this.campaignCOEB ? this.campaignCOEB.Users : [];
      inf.campaign_brief_details = this.campaignCOEB.campaign_brief_details;
      inf.id = data.id;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.signinForm = data.signinForm || null
      inf.contentScriptForm = data.contentScriptForm || false;
      inf.deliverables = deliverablesDetails
      inf.deliverablesDisplay = campaignHelper.getDeliverableDetails(deliverablesDetails)
      inf.sentStatus = influencerDetails.sentStatus || 0
      inf.platform = influencerDetails.platform || 'instagram'
      inf.platformName = inf.influencer_details.platformName || inf.platform;
      if (!inf.userHandle) inf.userHandle = inf.influencer_details.instagramHandle
      if (!inf.influencer_details.userHandle) inf.influencer_details.userHandle = inf.influencer_details.instagramHandle
      if (inf.platform === 'linkedin') {
        const linkedinHandle = inf.influencer_details.linkedinHandle || inf.influencer_details.userHandle || inf.influencer_details.instagramHandle
        inf.userHandle = linkedinHandle
        inf.influencer_details.userHandle = linkedinHandle
        inf.influencer_details.linkedinHandle = linkedinHandle
      }
      if (inf.platform === 'twitter') {
        const xHandle = inf.influencer_details.twitterHandle || inf.influencer_details.userHandle || inf.influencer_details.instagramHandle
        inf.userHandle = xHandle
        inf.influencer_details.userHandle = xHandle
        inf.influencer_details.twitterHandle = xHandle
      }
      if (inf.platform === 'facebook') {
        const facebookHandle = this.getFacebookHandle(inf.influencer_details)
        inf.userHandle = facebookHandle
        inf.influencer_details.userHandle = facebookHandle
        inf.influencer_details.facebookHandle = facebookHandle
      }
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName
        inf.xhsID = inf.xhsID
      }
      if (data.payout_details) {
        inf.payout_details = data.payout_details
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.GSTIncluded = data.payout_details.GSTpercent || false;
        inf.GSTpercent = data.payout_details.GSTpercent
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? reverse(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        inf.currency = data.payout_details.currency || 'SGD'
        if (inf.currency !== 'SGD') {
          inf.sgdAmt = utils.func.convertCurrency(inf.currency, inf.payoutAmount, this.currencyRates)
        }
        inf.payout_details.boostingFees = data.payout_details.boostingFees || []
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details
      }
      if (data.previousSigninForm) {
        inf.previousSigninForm = data.previousSigninForm
      }
      if (!inf.previousSigninForm) {
        if (inf.signinForm) {
          inf.previousSigninForm = [
            inf.signinForm
          ]
        }
      }
      return inf;
    },
    getAllUsers() {
      // Get all CO user by role
      UserAPIs
      .getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      .then(response => {
        this.Users = response.users
        this.Users = response.users.map(user => {
          user.name = `${user.firstName} ${user.lastName}`
          return user
        })
        this.getAllAMUsers()
      })
      .catch(error => {
        console.log('error', error);
      });
    },
    getAllAMUsers() {
      // Get all AM user by role
      UserAPIs
      .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      .then(response => {
        response.users.map(user => {
          user.name = `${user.firstName} ${user.lastName}`
          this.Users.push(user)
        })
      })
      .catch(error => {
        console.log('error', error);
      });
    },
    fetchCampaignList() {
      campaignAPIs
        .getAllCampaignsNoStatus() // In future, Campaign status could be change
        .then(response => {
          // let results = [];
          let campaigns = response
          campaigns = campaigns.filter(c => (c.status === config.campaignStatus.PAIRING_INFLUENCER ||
          c.status === config.campaignStatus.ONGOING ||
          c.status === config.campaignStatus.REVIEW ||
          c.status === config.campaignStatus.COMPLETE))
          // filter Others campaign
          // campaigns = campaigns.filter(campaign => {
          //   if (campaign.campaignType !== undefined) {
          //     if (campaignHelper.isOtherCampaign(campaign.campaignType)) {
          //       return true
          //     }
          //   }
          //   return false
          // })
          this.campaignList = campaigns.map(element => {
            // let campaign = {
            //   name: element.name,
            //   id: element.id
            // };
            // results.push(campaign);
            return {
              name: element.ioNumbers ? `${element.ioNumbers} - ${element.name}` : element.name,
              id: element.id,
              lockedCOGS: element.lockedCOGS || false
            };
          });
          // this.campaignList = results.sort((a, b) => {
          //   if (a.name > b.name) {
          //     return -1;
          //   }
          //   if (a.name < b.name) {
          //     return 1;
          //   }
          //   return 0;
          // });
          if (this.$route.query.id) {
            this.campaignID = this.$route.query.id
          }
        })
        .catch(err => {
          console.log('Error:' + err);
        });
    },
    getRptOwnerCheckPayload(item) {
      return Object.assign({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? (item.influencer_details.twitterHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle) : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      })
    },
    formatSubmissionDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : 'Empty!'
    },
    formatLiveMonth(date) {
      return date ? moment(date).format('MM/yyyy') : 'Empty!'
    },
    displayGSTText(item) {
      return `$${item.payoutAmount - item.GSTpercent} + $${item.GSTpercent} (GST)`
    },
    checkFinalPayoutConfirm(item) {
      let unConfirmed = this.pairedInfluencers.filter(p => p.id !== item.id && p.payout_details.status !== this.payoutStatus.CONFIRMED).length
      if (Number(this.measurement.total) < Number(this.campaignCOEB.min_content) || unConfirmed) {
        return false
      }
      return true
    },
    openLockedCOGSDialog(item) {
      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          const reqData = {
            campaignID: item.campaignId
          }
          await this.$store.dispatch('pairing/requestPayoutEdit', reqData)
          if (this.requestedPayoutEdit) {
            this.$swal({
              text: 'Successfully Requested.',
              type: 'success'
            })
          }
        }
      })
    },
    async changeLock(item, status) {
      const lockTxt = status ? 'Lock' : 'Unlock'
      this.$swal({
        title: `Are you sure to ${lockTxt}?`,
        icon: 'warning',
        confirmButtonText: lockTxt,
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          let updateObj = {
            id: item.campaignId,
            lockedCOGS: status
          }
          if (status === false) {
            updateObj.unlockCogsEmail = true
          }
          const updateData = [
            updateObj
          ]
          await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Campaign Update.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: `Successfully ${lockTxt}ed.`,
            type: 'success'
          });
          item.lockedCOGS = status
          // this.getCampaigns()
        }
        this.loadInfluencerData()
      })
    },
    copySignInFormLink(pairing) {
      this.copySucceeded = true
      const protocol = window.location.protocol
      const host = window.location.host
      this.signinFormLink = `${protocol}//${host}${config.SIGNING_IN_FORM_URL}/${pairing.id}`
      setTimeout(function() {
        pairing.linkCopied = utils.func.copyToClipboard('#copy-link')
      }, 100)
    },
    copyContentScriptFormLink(pairing) {
      this.copySucceeded = true
      const protocol = window.location.protocol
      const host = window.location.host
      this.conceptFormLink = `${protocol}//${host}/influencers/content-storyboard/${pairing.id}`
      setTimeout(function() {
        pairing.linkCopied = utils.func.copyToClipboard('#copy-concept-link')
      }, 100)
    },
    getSigninDataToView(viewData) {
      this.viewSigninFormData = viewData
      this.viewSigninFormModalDialog = true
    },
    downloadSigningPDF(signingForm) {
      if (signingForm.contractFile) {
        window.open(signingForm.contractFile.url, '_blank')
      }
    },
    signingFormsForDownload(item) {
      const previousForms = item && Array.isArray(item.previousSigninForm)
        ? item.previousSigninForm.slice().reverse()
        : []
      const forms = [item && item.signinForm, ...previousForms]
      const seenUrls = new Set()
      return forms.filter(form => {
        const url = form && form.contractFile && form.contractFile.url
        if (!url || seenUrls.has(url)) {
          return false
        }
        seenUrls.add(url)
        return true
      })
    },
    openUpdateEmailDialog(item) {
      this.viewPairingData = Object.assign({}, item)
      this.updateCreatorEmailDialog = true
    },
    openUpdateSubmissionDialog(item) {
      this.viewPairingData = Object.assign({}, item)
      this.updateSubmissionDateDialog = true
    },
    openEstimatedLiveDateDialog(item) {
      this.multiplePairings = []
      this.viewPairingData = Object.assign({}, item)
      this.updateEstimatedLiveDateDialog = true
    },
    openMultipleEstimatedLiveDateDialog() {
      this.multiplePairings = Object.assign([], this.selectedItems)
      this.updateEstimatedLiveDateDialog = true
    },
    // NEW: Method for bulk submission date update
    openMultipleSubmissionDateDialog() {
      this.multiplePairings = Object.assign([], this.selectedItems)
      this.updateMultipleSubmissionDateDialog = true
    },
    async refreshPairingInfFromIMS(item) {
      this.loadingDialog = true
      let campaignID = item.campaignId
      // await pairingAPIs.refreshPairingInfFromIMS(campaignID)
      await this.getPairedInfluencers(campaignID)
      this.loadingDialog = false
    },
    async getAllClients() {
      let response = await clientAPIs.getAllClients(false)
      this.allClients = response.data;
    },
    cancelAccept(item) {
      this.$swal({
        title: 'Cancel Accept',
        html: 'Are you sure to cancel accept?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          const reqData = {
            id: item.id
          }
          await this.$store.dispatch('pairing/cancelPairingStatus', reqData)
          if (this.saved) {
            this.$swal({
              text: 'Successfully Canceled Accept.',
              type: 'success'
            })
            this.getPairedInfluencers(this.campaignID)
          }
        }
      })
    },
    async viewContentScriptDialog(id) {
      this.viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(id)
      if (!this.viewContentScriptsData) {
        this.$swal({
          text: 'No Content Scripts Data.',
          type: 'warning'
        })
      }
      this.viewcontentScriptModalDialog = true
      console.log('content script dialog')
    },
    async setMultipleInfs() {
      for (let item of this.pairedInfluencers) {
        if (!item.influencerID) {
          continue
        }
        let infs = []
        await this.$store.dispatch('influencer/getInfluencerDetail', {
          id: item.influencerID
        })
        if (this.infDetail.instagram) {
          infs.push({
            handle: this.infDetail.instagram.instagramHandle,
            instagramID: this.infDetail.instagram.instagramID,
            picture: this.infDetail.audience ? this.infDetail.audience.user_profile.picture : this.infDetail.instagram.picture,
            instagram: true,
            platform: 'instagram'
          })
        }
        if (this.infDetail.tiktok) {
          infs.push({
            handle: this.infDetail.tiktok.tiktokHandle,
            tiktokID: this.infDetail.tiktok.tiktokID,
            picture: this.infDetail.tiktokaudience ? this.infDetail.tiktokaudience.user_profile.picture : this.infDetail.tiktok.picture,
            tiktok: true,
            platform: 'tiktok'
          })
        }
        if (this.infDetail.youtube) {
          infs.push({
            handle: this.infDetail.youtube.youtubeHandle,
            youtubeID: this.infDetail.youtube.youtubeID,
            picture: this.infDetail.youtubeaudience ? this.infDetail.youtubeaudience.user_profile.picture : this.infDetail.youtube.picture,
            youtube: true,
            platform: 'youtube'
          })
        }
        if (this.infDetail.xiaohongshu) {
          infs.push({
            handle: this.infDetail.xiaohongshu.xhsHandle,
            xhsID: this.infDetail.xiaohongshu.xhsID,
            picture: this.infDetail.xiaohongshu ? this.infDetail.xiaohongshu.profilePicture : '',
            xhs: true,
            platform: 'xiaohongshu'
          })
        }
        if (this.infDetail.facebook) {
          const facebookHandle = this.infDetail.facebook.handle || this.infDetail.facebook.facebookHandle || this.infDetail.facebook.facebookId || ''
          infs.push({
            handle: facebookHandle,
            xhsID: this.infDetail.facebook.facebookId,
            picture: this.infDetail.facebook ? this.infDetail.facebook.profilePicture : '',
            facebook: true,
            platform: 'facebook'
          })
          if (item.influencer_details.platform === 'facebook' && facebookHandle) {
            this.$set(item.influencer_details, 'facebookHandle', facebookHandle)
            this.$set(item.influencer_details, 'userHandle', facebookHandle)
            this.$set(item, 'userHandle', facebookHandle)
          }
        }
        if (this.infDetail.linkedin) {
          infs.push({
            handle: this.infDetail.linkedin.linkedinHandle,
            picture: '',
            linkedin: true,
            platform: 'linkedin'
          })
        }
        if (this.infDetail.twitter) {
          infs.push({
            handle: this.infDetail.twitter.twitterHandle,
            picture: '',
            twitter: true,
            platform: 'twitter'
          })
        }
        item.multipleInfs = infs
      }
      this.pairedInfluencers = Object.assign([], this.pairedInfluencers)
    },
    selectAllItems($event) {
      if (!$event.value) {
        this.items = this.pairedInfluencers.map(i => { i.isSelected = false; return i; })
      } else {
        this.pairedInfluencers = this.pairedInfluencers.map(i => {
          i.isSelected = true
          return i;
        })
      }
      this.actionSelectChange()
    },
    actionSelectChange() {
      this.selectedItems = this.pairedInfluencers.filter(i => i.isSelected)
    }
  }
};
</script>

<style scoped>
.page__table ::v-deep th.invoice-handle-column,
.page__table ::v-deep td.invoice-handle-column {
  min-width: 210px;
}

.page__table ::v-deep th.invoice-platform-column,
.page__table ::v-deep td.invoice-platform-column {
  min-width: 170px;
}

.assign-am-cc-btn {
  color: var(--ims-color-ink) !important;
  font-weight: 700;
  letter-spacing: 0;
  pointer-events: none;
}

.assign-am-cc-btn ::v-deep .v-btn__content,
.assign-am-cc-btn ::v-deep .v-icon {
  color: var(--ims-color-ink) !important;
}
</style>



// WEBPACK FOOTER //
// InvoicesBriefConfirmation.vue?9dc65c14